import React from 'react';

import useGroupSubscription from '../../../../hooks/useGroupSubscription';
import useTeam from '../../../../hooks/useTeam';
import SubscriptionOverview from '../../../Subscription/Gift/SubscriptionOverview';
import SettingsHeading from '../SettingsHeading';
import AddTeamMembers from './AddTeamMembers';
import EmailDomainForm from './EmailDomainForm';
import NameForm from './NameForm';
import SignupLink from './SignupLink';
import styles from './styles.module.css';

export default function Team() {
  const { team } = useTeam();
  const { data: recipients } = useGroupSubscription({ type: 'team' });

  return (
    <div className={styles.teamSettings}>
      <div className={styles.teamSettingsSection}>
        <NameForm team={team} />
        {!!team && (
          <div data-test="team-access-settings">
            <SignupLink team={team} />
            <EmailDomainForm team={team} />
            <AddTeamMembers />
          </div>
        )}
      </div>

      {!!team && (
        <div data-test="team-additional-settings">
          <div className={styles.teamSettingsSection}>
            <SettingsHeading title="Enterprise Functionality">
              Need more enterprise functionality like SSO, advanced billing options, higher seat
              counts, etc., reach out to{' '}
              <a href="mailto:enterprise@theinformation.com">enterprise@theinformation.com</a>
            </SettingsHeading>
          </div>
          <div className={styles.teamSettingsSection}>
            <SettingsHeading title="Subscriptions">
              You are currently supporting the following subscriptions for others to The Information
            </SettingsHeading>
            {!!recipients && <SubscriptionOverview recipients={recipients} team={true} />}
          </div>
        </div>
      )}
    </div>
  );
}
